import { DebriefingClientRollupPanel } from './DebriefingClientRollupPanel';
import { DebriefingsTable } from './DebriefingsTable';

interface Props {
    matterId?: string;
    clientPartyId?: string;
}

/**
 * Embedded Debriefings tab, shared by the Case page (matterId) and the Client page
 * (clientPartyId, which also gets the rollup panel).
 */
export function DebriefingsView({ matterId, clientPartyId }: Props) {
    if (!matterId && !clientPartyId) {
        return null;
    }
    if (matterId) {
        return <DebriefingsTable variant="case-tab" matterId={matterId} />;
    }
    return (
        <div className="new:gap-(--card-gap) flex flex-col gap-4">
            <DebriefingClientRollupPanel clientPartyId={Number(clientPartyId)} />
            <DebriefingsTable variant="client-tab" clientPartyId={clientPartyId} />
        </div>
    );
}
